import React, { useState, useEffect } from 'react';
import '../styles/OilCompare.css';

const OilComparison = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeCard, setActiveCard] = useState(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleWhatsAppRedirect = () => {
    const phoneNumber = '917019272992';
    const message = "Hi, I'm interested in purchasing your products. Could you please share more details?"
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank'); // Opens WhatsApp in new tab
  };

  const comparisonData = [
    {
      feature: "Extraction Method",
      coldPressed: "Pressed at low temperature using wooden churners (Ghani)",
      refined: "High-heat chemical-based extraction",
      icon: "🔧"
    },
    {
      feature: "Nutrient Retention",
      coldPressed: "Retains natural vitamins (E, K), antioxidants, and essential fatty acids",
      refined: "Most nutrients lost due to high heat and refining agents",
      icon: "🌱"
    },
    // {
    //   feature: "Additives",
    //   coldPressed: "100% chemical-free, no preservatives or artificial agents",
    //   refined: "Often contains solvents, deodorants, and stabilizers",
    //   icon: "⚗️"
    // },
    {
      feature: "Taste & Aroma",
      coldPressed: "Natural flavor and aroma of the seed/nut retained",
      refined: "Neutral or artificial taste; aroma is often masked",
      icon: "👃"
    },
    {
      feature: "Health Benefits",
      coldPressed: "Boosts immunity, heart health, and digestion",
      refined: "May contain trans fats and residues harmful over time",
      icon: "❤️"
    },
    {
      feature: "Shelf Life",
      coldPressed: "Moderate (natural without preservatives)",
      refined: "Longer shelf life due to added chemicals",
      icon: "📅"
    },
    {
      feature: "Usage",
      coldPressed: "Suitable for cooking, skin, and hair care",
      refined: "Mostly used for cooking only",
      icon: "🍳"
    }
  ];

  return (
    <div className="oil-comparison-container">
      <div className={`hero-section ${isVisible ? 'animate-in' : ''}`}>
        <div className="floating-particles">
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
        </div>

        <h2 className="main-title">
          <span className="title-line">Cold Pressed Oils</span>
          <span className="vs-text">VS</span>
          <span className="title-line">Refined Oils</span>
        </h2>

        <p className="subtitle">
          Choosing the right cooking oil matters—for your health, taste, and overall well-being.
          Here's how cold pressed oils stand apart from refined oils, and why
          <strong> Haronics Cold Pressed Oils</strong> are a better choice:
        </p>
      </div>

      <div className="comparison-grid">
        {comparisonData.map((item, index) => (
          <div
            key={index}
            className={`comparison-card ${isVisible ? 'slide-in' : ''}`}
            style={{ animationDelay: `${index * 0.1}s` }}
            onMouseEnter={() => setActiveCard(index)}
            onMouseLeave={() => setActiveCard(null)}
          >
            <div className="card-header">
              <span className="feature-icon">{item.icon}</span>
              <h3 className="feature-title">{item.feature}</h3>
            </div>

            <div className="card-content">
              <div className={`oil-type cold-pressed ${activeCard === index ? 'active' : ''}`}>
                <h4>Cold Pressed Oils (Haronics)</h4>
                <p>{item.coldPressed}</p>
                <div className="quality-indicator good"></div>
              </div>

              <div className="divider"></div>

              <div className={`oil-type refined ${activeCard === index ? 'active' : ''}`}>
                <h4>Refined Oils</h4>
                <p>{item.refined}</p>
                <div className="quality-indicator poor"></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={`cta-section ${isVisible ? 'fade-in-up' : ''}`}>
        <div className="cta-content">
          <h2>Make the Healthy Choice Today!</h2>
          <p>Experience the pure, natural goodness of Haronics Cold Pressed Oils</p>
          <button className="cta-button" onClick={handleWhatsAppRedirect} >
            <span>Choose Haronics</span>
            <div className="button-ripple"></div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default OilComparison;
